/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import Empresa from 'Models/cadastros/Empresa'
import {
  ExportParamsBodyRequest,
  ExportParamsRequest,
  ParamsRequest,
} from 'Services/__shared/types/resquest'
import ApiService from 'Services/ApiService'
import {
  ServiceListResponse,
  ServiceCreateResponse,
  ServiceUpdateResponse,
} from 'Types/ServiceResponse'
import IFormEmpresasFilter from 'Views/Cadastros/Empresas/IFormEmpresasFilter'

const empresas = {
  getList: async (
    idComponente: number,
    filter?: IFormEmpresasFilter,
    params?: ParamsRequest,
  ) => {
    const result: AxiosResponse<ServiceListResponse<Empresa>> =
      await ApiService({ idComponente }).get<ServiceListResponse<Empresa>>(
        QueryStringFilter(`${hosts.WS_CADASTRO}/Empresa`, filter, params),
      )

    return result
  },
  details: async (idComponente: number, id: number) => {
    const result: AxiosResponse<Empresa> = await ApiService({
      idComponente,
    }).get<Empresa>(`${hosts.WS_CADASTRO}/Empresa/${id.toString()}`)

    return result
  },
  export: async (
    idComponente: number,
    filter: IFormEmpresasFilter,
    params?: ExportParamsRequest,
    exportFields?: ExportParamsBodyRequest,
  ) => {
    const result: AxiosResponse<string> = await ApiService({
      idComponente,
    }).post<string>(
      QueryStringFilter(
        `${hosts.WS_CADASTRO}/Empresa/Exportar`,
        filter,
        params,
      ),
      exportFields,
    )

    return result
  },
  create: async (idComponente: number, data: Empresa) => {
    const result: AxiosResponse<ServiceCreateResponse> = await ApiService({
      idComponente,
    }).post<Empresa>(`${hosts.WS_CADASTRO}/Empresa`, data)

    return result
  },
  update: async (idComponente: number, data: Empresa, id?: string) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<Empresa>(`${hosts.WS_CADASTRO}/Empresa/${id}`, data)

    return result
  },
}

export default empresas
